module.exports = __webpack_public_path__ + "../resources/images/outlookLogo24-ed01937e54f801347649ab69ae73e6b3.svg";